import React from 'react';
import { styles } from './ErrorSuccessTabs.css';
import CircleIcon from '@jbhi-fi/lanyard-ui/components/Icons/Circle';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import {
  DELIVERY_UNAVAILABLE_MESSAGE,
  ERROR_MESSAGE,
  ERROR_MESSAGE_DELIVERY,
  IN_STORE_ONLY_DELIVERY_UNAVAILABLE_MESSAGE,
} from '../../../../availability/utils/constants';

export const UnavailableForDelivery = ({
  children,
  isInStoreOnly,
  isError,
}: {
  children?: React.ReactNode;
  isInStoreOnly?: boolean;
  isError?: boolean;
}) => {
  const getMessage = () => {
    if (isError) {
      return `${ERROR_MESSAGE} ${ERROR_MESSAGE_DELIVERY}`;
    } else if (isInStoreOnly) {
      return IN_STORE_ONLY_DELIVERY_UNAVAILABLE_MESSAGE;
    } else {
      return DELIVERY_UNAVAILABLE_MESSAGE;
    }
  };
  return (
    <>
      {children}
      <div className={styles.unavailableContainer}>
        <div className={styles.iconContainer}>
          <CircleIcon color={palette.error.main} />
        </div>
        <span>{getMessage()}</span>
      </div>
    </>
  );
};
